import { AccessoryDto } from "@/core/api/generated/v1";

import BaseEntityAutocompleteOrCreate, {
  AutocompleteType,
  BaseEntityAutocompleteOrCreateInheritableProps,
} from "../components/BaseEntityAutocompleteOrCreate";
import AccessoryAutocomplete, { AccessoryAutocompleteProps } from "./AccessoryAutocomplete";
import AccessoryCreateUpdate, { AccessoryCreateUpdateProps } from "./AccessoryCreateUpdate";
import AccessoryCreateUpdateModal from "./AccessoryCreateUpdateModal";

type Props = BaseEntityAutocompleteOrCreateInheritableProps<
  AccessoryDto,
  AccessoryCreateUpdateProps["defaultValues"],
  AccessoryAutocompleteProps,
  AccessoryCreateUpdateProps
>;

export default function AccessoryAutocompleteOrCreate({ ...otherProps }: Props) {
  return (
    <BaseEntityAutocompleteOrCreate<
      AccessoryDto,
      AccessoryCreateUpdateProps["defaultValues"],
      AccessoryAutocompleteProps,
      AccessoryCreateUpdateProps
    >
      autocompleteType={AutocompleteType.Single}
      getDefaultValues={(params) => params.createUpdateProps?.defaultValues}
      renderAutocomplete={(params) => (
        <AccessoryAutocomplete
          {...params.autocompleteProps}
          withCreate
          createOptionTitle={(inputValue) => `Create new accessory "${inputValue}"`}
          onCreate={(newOption) => {
            params.setDefaultValues({
              ...params.defaultValues,
              name: newOption?.inputValue || params.defaultValues?.name || undefined,
            });
            params.setIsCreate(true);
            params.onCreateStart && params.onCreateStart();
          }}
        />
      )}
      renderCreateUpdate={(params) => (
        <AccessoryCreateUpdate
          {...params.createUpdateProps}
          defaultValues={params.defaultValues}
          onCreate={params.onCreate}
          onSave={(newValue) => {
            params.setIsCreate(false);
          }}
        />
      )}
      renderCreateUpdateModal={(params) => (
        <AccessoryCreateUpdateModal
          open={params.isCreate}
          onClose={() => params.setIsCreate(false)}
          createUpdateProps={{
            ...params.createUpdateProps,
            defaultValues: params.defaultValues,
            onCreate: params.onCreate,
            onSave: (newValue) => {
              params.setIsCreate(false);
            },
          }}
        />
      )}
      {...otherProps}
    />
  );
}
